module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-4-668ce3e6c25c6e4a8e863c482a97545b.jpg";